import stringFunctions from "@/functions/stringFunctions";

var forumFunctions = {
	formatPostTextForDisplay(post) {
		if (post.messageDateSerial + post.messageTimeSerial > process.env.VUE_APP_SITE_LIVE_DATE) {
			return post.message
		} else {
			return stringFunctions.htmlDecode(post.message);
		}
	},
	formatMailTextForDisplay(mail) {
		if (mail.messageId > process.env.VUE_APP_MAIL_LAST_OLD_FORMAT_MESSAGE_ID) {
			return mail.message
		} else {
			return stringFunctions.htmlDecode(mail.message);
		}
	},
	getImageFullUrl(imagePath) {
		return process.env.VUE_APP_AVATAR_BASE_URL_NEW + imagePath
	},

}

export default forumFunctions